import {useEffect} from 'react'
import useMutate from '@packages/apollo-hooks/lib/useMutate'
import gql from 'graphql-tag'
import useWebsiteId from '@hooks/useWebsiteId'
import useQuery from '@packages/apollo-hooks/lib/useApolloQuery'

export default function useAddressOutOfBounds({storeId, placeId}) {
  const mutate = useMutate()
  const websiteId = useWebsiteId()

  const {website} = useQuery({
    query: gql`
      query getWebsiteNoStoreMessage_cached($websiteId: ID) {
        website(websiteId: $websiteId) {
          _id
          menuConfiguration {
            deliveryNoStoreMessage
          }
        }
      }
    `,
    variables: {websiteId},
    fetchPolicy: 'cache-first',
    partial: true
  })

  if (!placeId || storeId) {
    return null
  }

  let outOfDeliveryZoneMessage = null
  if (website) {
    outOfDeliveryZoneMessage =
      website.menuConfiguration.deliveryNoStoreMessage || 'Lo sentimos, no llegamos a tu dirección'
  }

  return outOfDeliveryZoneMessage
}
